import React from "react";
import logonewnew from "../logonewnew.svg";
const Header = () => {
  return (
    <section className="home-section">
      <nav
        className="navbar navbar-expand-lg navbar-custom position-absolute sticky sticky-light"
        id="navbar"
      >
        <div className="container">
          <a
            className="navbar-brand logo text-uppercase text-white fw-bold"
            href="index-1.html"
          >
            <img src={logonewnew} alt="" height="20" />
            {/* <img
              src="img/logo-dark.svg"
              className="logo-dark"
              alt=""
              height="25"
            /> */}
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="mdi mdi-menu"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav ms-auto" id="navbar-navlist">
              <li className="nav-item">
               
              </li>
              <li className="nav-item">
                
              </li>

              <li className="nav-item">
               
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </section>
  );
};

export default Header;
